var _path, _linearGradient;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrayon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 60,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.373 60H0V32.968a60.84 60.84 0 013.804-21.174l3.839-10.25a2.378 2.378 0 014.46.02l3.725 10.23A48.015 48.015 0 0119.373 29.9V60z",
    fill: "url(#crayon_svg__a)"
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "crayon_svg__a",
    x1: 0,
    y1: 53.5,
    x2: 20,
    y2: 53.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.234,
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "currentColor",
    stopOpacity: 0.5
  }))));
}

export default SvgCrayon;